const APPCONFIG = {
  version: '1.6.42',
  env: 'DEV',
  currency: 'D',
  currencyRegularExpresion: /\D/g
}
export default APPCONFIG
